// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3OwwF","header":"PatientQuestionnaire_header__1J6QV","info":"PatientQuestionnaire_info__QLr1-"};